module.exports = __webpack_public_path__ + "img/icon-moonpay.4cc5754c.svg";